export default __webpack_public_path__ + "static/media/Jogo-Do-Bicho_Music_1.f3f39964.svg";